export default function Footer() {

    const year = new Date().getFullYear()



    return (
        <footer className="border-t border-accent h-14 fixed bottom-0 left-0 z-100 w-full p-5 sm:flex md:items-center md:justify-between bg-background animate-fade animate-once animate-duration-[1500ms] animate-delay-100 animate-ease-in-out">
            <span className="text-sm text-white font-semibold sm:text-center lg:text-lg">© {year}, Phil Juricev. All Rights Reserved.</span>
        </footer>
    )
}
